// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"566":"7f11f879","728":"8f10f735","821":"7b0b0bbd"}[chunkId] + ".chunk.js";
};